import { useState } from 'react';
import { RegenerateState } from '../interfaces/ui';

export default function useRegenerateState() {
  const [regenerateState, setRegenerateState] = useState<RegenerateState>({
    showConfirmation: false,
    projectId: null,
  });

  const openRegenerateDialog = (projectId: string) =>
    setRegenerateState({ showConfirmation: true, projectId });

  const closeRegenerateDialog = () =>
    setRegenerateState({ showConfirmation: false, projectId: null });

  const confirmRegenerate = (onConfirm: (projectId: string) => void) => {
    if (regenerateState.projectId) onConfirm(regenerateState.projectId);
    closeRegenerateDialog();
  };

  return {
    regenerateState,
    openRegenerateDialog,
    closeRegenerateDialog,
    confirmRegenerate,
  };
}
